import { EnvironmentService } from "./../services/environment.service";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Inject, Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";
import { AuthType } from "../models/globals";
import { PING_IDENTITY_CONFIG } from "../models/ping-auth-config.token";
import { AuthConfig } from "angular-oauth2-oidc";

@Injectable()
export class AuthJwtInterceptorService implements HttpInterceptor {
  excludedDomains: string[] = [];
  constructor(
    private authenticationService: AuthenticationService,
    private _environmentService: EnvironmentService,
    @Inject(PING_IDENTITY_CONFIG) private pingConfig: AuthConfig
  ) {
    if (pingConfig.issuer) {
      const issuerDomain = new URL(pingConfig.issuer!).origin;
      this.excludedDomains = [issuerDomain];
    }
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.token;
    const localStorageUser =
      this.authenticationService.getLoggedInUserFromLocalStorage();

    const isApiUrl = request.url.startsWith(
      this._environmentService?.envVariables?.httpProtocol +
      this._environmentService?.envVariables?.webHost
    );

    const isOidcRequest = this.excludedDomains.some((oidcUrl) =>
      request.url.startsWith(oidcUrl)
    );
    if (isOidcRequest) {
      return next.handle(request);
    }

    if (isLoggedIn && (isApiUrl || (request.url.includes("zip")) && !request.url.includes("amazonaws.com"))) {
      if (currentUser?.username != localStorageUser) {
        this.authenticationService.logout();
        return next.handle(request);
      }
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
          UserId: currentUser.username,
        },
      });
    }

    if (
      this.authenticationService.getAuthenticationType() !=
      AuthType.SyncHPCAPI &&
      !request.url.includes("5011")
    ) {
      let isadminlogin = localStorage.getItem("isadminlogin");
      let isadminsession = localStorage.getItem("isadminsession");
      // If the authentication type
      request = request.clone({
        setHeaders: {
          AuthenitcationType: String(
            this.authenticationService.getAuthenticationType()
          ),
          isadminlogin: isadminlogin ? isadminlogin : "false",
          isadminsession: isadminsession ? isadminsession : "false"
        },
      });
    }
    return next.handle(request);
  }
}
